import { useMediaQuery } from "react-responsive";

export function useDevice() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1100 });
  const isDesktop = useMediaQuery({ minWidth: 1025 });

  const isSmallDevice = isMobile || isTablet;

  return { isMobile, isTablet, isDesktop, isSmallDevice };
}
